import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import { AUGUST_PROMOTION_LANDING_PAGE_LINK } from 'constants/links'
import Box from 'components/shared/Box'
import Link from 'components/shared/Link'

const AugustPromotionInitialInfo = () => {
    const augustPromotionInfo = (
        <Text variant="body" color="grayscale_800">
            <FormattedMessage
                id="promo.august.creator_discount_info"
                defaultMessage="Zaplanuj wizytę między 20.08 a 01.09 i otrzymaj 50% zniżki na następny raz! "
            />
        </Text>
    )

    const augustPromotionLink = (
        <Link
            path={AUGUST_PROMOTION_LANDING_PAGE_LINK}
            target="_blank"
            variant="primary"
            textVariant="body"
            icon={null}
            isUnderlined
        >
            <FormattedMessage
                id="promo.august.creator_discount_info_details"
                defaultMessage="Sprawdź szczegóły"
            />
        </Link>
    )

    return (
        <Box mb={[24, 40]}>
            {augustPromotionInfo}
            {augustPromotionLink}
        </Box>
    )
}

export default AugustPromotionInitialInfo
